
import React from 'react';

interface StarRatingProps {
  rating: number;
  onChange?: (rating: number) => void;
  size?: number;
  interactive?: boolean;
}

export const StarRating = ({ 
  rating, 
  onChange, 
  size = 20, 
  interactive = false 
}: StarRatingProps) => {
  const stars = Array.from({ length: 5 }, (_, i) => i + 1);
  
  const handleClick = (star: number) => {
    if (interactive && onChange) {
      // Toggle the star off if it's clicked again
      if (star === rating) {
        onChange(0);
      } else {
        onChange(star);
      }
    }
  };

  return (
    <div className="flex">
      {stars.map((star) => (
        <button
          key={star}
          type={interactive ? "button" : undefined}
          onClick={() => handleClick(star)}
          className={`text-${star <= rating ? 'amber-500' : 'gray-300'} ${
            interactive ? 'cursor-pointer hover:text-amber-400' : ''
          } transition-colors`}
          aria-label={`${star} ${star === 1 ? 'Stern' : 'Sterne'}`}
          disabled={!interactive}
          style={{ background: 'transparent', border: 'none', padding: '2px' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </button>
      ))}
    </div>
  );
};
